/** A single event payload pushed onto the GTM `dataLayer`. */
export type GTMEvent = Record<string, unknown>

/**
 * Pushes an event to the Google Tag Manager `dataLayer`. Browser-only (a no-op
 * during SSR / non-DOM environments). Replaces `@next/third-parties/google`'s
 * `sendGTMEvent` with a framework-agnostic equivalent while keeping the same
 * public signature so callers are unaffected.
 */
export function sendGTMEvent(event: GTMEvent): void {
  if (typeof window === 'undefined') return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(event)
}
